import React, { useContext, createContext } from 'react';
import type { FC, ReactNode } from 'react';

interface ArmTag {
  armTag: string;
}

const ArmTagContext = createContext<ArmTag | null>(null);

export const ArmTagProvider: FC<{ children: ReactNode; armTag: string }> = ({
  children,
  armTag,
}) => {
  return (
    <ArmTagContext.Provider value={{ armTag }}>
      {children}
    </ArmTagContext.Provider>
  );
};

export const useArmTag = () => {
  const context = useContext(ArmTagContext);

  if (context == null) {
    throw new Error('useArmTag() cannot be used without an <ArmTagProvider>');
  }

  return context;
};
